import PropTypes from 'prop-types';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { SkeletonLoader } from 'cat-ecommerce-alloy';
import ProductListItemsCount from '@app/components/common/ProductListItemsCount';
import ProductListLoadMore from '../ProductListLoadMore';
import cx from 'classnames';

const ProductListBottomContainer = ({
  isLoadingGetMoreResults,
  catalogEntriesLength,
  recordSetTotal,
  showLoadMore
}) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  return (
    <div className="row mx-0 d-flex align-items-center mt-3">
      <div className="col-12 col-md-4 p-0">
        {isLoadingGetMoreResults ? (
          <SkeletonLoader
            className={cx('w-100 height-30px', {
              'mt-3 mb-3': !isMD
            })}
          />
        ) : (
          <ProductListItemsCount
            currentItemsCount={catalogEntriesLength}
            totalItemsCount={recordSetTotal}
            isMD={isMD}
          />
        )}
      </div>
      {showLoadMore && (
        <div className="col-12 col-md-4 p-0">
          <ProductListLoadMore />
        </div>
      )}
    </div>
  );
};

ProductListBottomContainer.propTypes = {
  isLoadingGetMoreResults: PropTypes.bool,
  catalogEntriesLength: PropTypes.number,
  recordSetTotal: PropTypes.number,
  showLoadMore: PropTypes.bool
};

export default ProductListBottomContainer;
